import React, { Component } from 'react';
import logo from '../../img/s-v-t.svg';
import './EndPage.css';
import { Button, ControlLabel, FormControl, FormGroup } from 'react-bootstrap';
import { sendResultToServer, updateComment, updateHearability, updateAgeRange } from "../../redux/actions";
import { connect } from "react-redux";
import { ALLOW_COMMENTS } from '../../services/config'

class EndPage extends Component {

    constructor(props) {
        super(props)
        this.state = { resultsSent: false }
    }

    finish = (source) => {
        this.props.sendResultToServer().then(() => this.setState({ resultsSent: true }))
    };

    ranges = [
        "Under 20",
        "21-40",
        "41-60",
        "61-80",
        "Över 80",
    ]

    handleTextChange = (e) => {
        this.props.updateComment(e.target.value);
    };

    handleRadioChange = (score) => {
        console.log(this.props.videotest.get("perceivedHearability"))
        this.props.updateRadioValue(score)
    }

    handleDropdownChange = (event) => {
        console.log(event)
        this.props.updateAgeRange(event.target.value)
    }

    componentDidMount() {
        // if we don't allow comments, just send the results
        if (!ALLOW_COMMENTS) {
            this.finish("no comments allowed")
        }
    }

    getFinishedText = () => {
        const client = this.props.videotest.get("device").os.name;
        if (client === "iOS") {
            return 'Tryck på knappen "klar" uppe till vänster för att gå tillbaka till SVT play! (eller stäng fliken om du gör testet i safari)'
        }
        else {
            return "Tryck på knappen för att gå tillbaka till SVT play!"
        }
    }

    render() {

        const commentForm = (
            <div className='form-container'>
                {this.state.resultsSent ? (<div>
                    <h1>
                        Tack för din medverkan!
                    </h1>
                </div>) : (
                    <div className='input-container'>

                        <div className="TextArea">
                            <h1>
                                Nästan klar!
                            </h1>
                            <h2>Hur gammal är du?</h2>
                            <div className='dropdown-container'>
                                <select name="age" id="age-select" onChange={this.handleDropdownChange}>
                                    {this.ranges.map(opt => (
                                        <option value={opt}>{opt}</option>
                                    ))}
                                </select>
                            </div>


                            <FormGroup controlId="formControlsTextarea">
                                <ControlLabel>Här kan du lämna eventuella kommentarer</ControlLabel>
                                <FormControl componentClass="textarea"
                                    placeholder="Skriv kommentarer här"
                                    onChange={this.handleTextChange} />
                            </FormGroup>
                            <p>
                                Annars är det bara att skicka in resultatet med knappen nedan.
                            </p>
                            <Button className="btn btn-primary" onClick={() => this.finish("the button")}>
                                Skicka in resultatet
                            </Button>
                        </div>
                    </div>)
                }
            </div>);


        return (
            <div className="App">
                <div className="App-header">
                    <h1>
                        <img src={logo} className="App-logo" alt="logo" />
                    </h1>
                    <button disabled={!this.state.resultsSent} onClick={() => window.history.back()} className={this.state.resultsSent ? "btn btn-primary" : "btn btn-disabled"}>Gå tillbaka</button>
                </div>
                {
                    !ALLOW_COMMENTS ?
                        (<div className="ThankYouArea">
                            <h1>
                                Tack för din medverkan!
                            </h1>
                            {!this.state.resultsSent && (
                                <p>Skickar dina svar...</p>
                            )}
                            {this.state.resultsSent &&
                                (<p> Nu är dina svar inskickade! {this.getFinishedText()}</p>)}
                            <button disabled={!this.state.resultsSent} onClick={() => window.history.back()} className={this.state.resultsSent ? "btn btn-primary" : "btn btn-disabled"}>Gå tillbaka</button>
                        </div>)
                        : commentForm
                }
            </div>
        );
    }
}


const mapStateToProps = state => ({
    videotest: state.get('videotest')
});

const mapDispatchToProps = dispatch => {
    return {
        updateComment: (text) => dispatch(updateComment(text)),
        sendResultToServer: () => dispatch(sendResultToServer()),
        updateRadioValue: (score) => dispatch(updateHearability(score)),
        updateAgeRange: (ageRange) => dispatch(updateAgeRange(ageRange))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(EndPage);



// WEBPACK FOOTER //
// ./src/components/EndPage/EndPage.js